import { Link } from "react-router-dom";
import { Instagram, Lock, MessageCircle, Youtube } from "lucide-react";
import { whatsappHref } from "@/lib/useSettings";

const SocialLink = ({ testid, href, label, children }) => (
  <a
    data-testid={testid}
    href={href}
    target="_blank"
    rel="noreferrer"
    aria-label={label}
    className="w-11 h-11 border border-line flex items-center justify-center text-ash hover:text-amber hover:border-amber/50 transition-all duration-300"
  >
    {children}
  </a>
);

export const Footer = ({ onNavigate, settings }) => (
  <footer data-testid="footer" className="relative border-t border-ivory/10 bg-coal/60 overflow-hidden">
    <div
      aria-hidden
      className="absolute inset-x-0 top-0 h-40 pointer-events-none"
      style={{
        background: "linear-gradient(180deg, rgba(247,244,238,0.05) 0%, transparent 100%)",
      }}
    />
    <div className="max-w-[1500px] mx-auto px-5 sm:px-10 pt-20 pb-10">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-12">
        <div>
          <div className="flex items-center gap-4">
            <img src="/logo.jpeg" alt="ANSH AGARWAL FILMS logo" className="w-14 h-14 object-cover rounded-sm ring-1 ring-ivory/20" />
            <p className="font-display text-2xl sm:text-3xl tracking-[0.25em] text-ivory uppercase leading-tight">
              Ansh Agarwal
              <span className="block text-xs tracking-[0.6em] text-amber mt-1">Films</span>
            </p>
          </div>
          <p className="font-serif italic text-ash mt-6 max-w-sm">
            Painting with light &amp; time — from Mumbai &amp; New Delhi to anywhere your story lives.
          </p>
        </div>
        <nav className="flex flex-wrap gap-x-10 gap-y-4">
          {[
            ["#work", "Work", "footer-link-work"],
            ["#films", "Films", "footer-link-films"],
            ["#about", "About", "footer-link-about"],
            ["#services", "Services", "footer-link-services"],
            ["#contact", "Contact", "footer-link-contact"],
          ].map(([id, label, testid]) => (
            <button
              key={id}
              data-testid={testid}
              onClick={() => onNavigate(id)}
              className="font-mono text-[10px] tracking-[0.3em] uppercase text-ash hover:text-amber transition-colors"
            >
              {label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          {settings.instagram && (
            <SocialLink testid="footer-social-instagram" href={settings.instagram} label="Instagram">
              <Instagram size={15} />
            </SocialLink>
          )}
          {settings.youtube && (
            <SocialLink testid="footer-social-youtube" href={settings.youtube} label="YouTube">
              <Youtube size={15} />
            </SocialLink>
          )}
          {settings.whatsapp && (
            <SocialLink testid="footer-social-whatsapp" href={whatsappHref(settings.whatsapp)} label="WhatsApp">
              <MessageCircle size={15} />
            </SocialLink>
          )}
          <Link
            to="/admin"
            data-testid="footer-admin-link"
            aria-label="Admin"
            className="w-11 h-11 border border-line flex items-center justify-center text-ash hover:text-amber hover:border-amber/50 transition-all duration-300"
          >
            <Lock size={14} />
          </Link>
        </div>
      </div>
      <div className="border-t border-line mt-14 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-mute">
          © 2026 Ansh Agarwal Films. All frames reserved.
        </p>
        <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-mute">
          Crafted in light — 19.07° N, 72.87° E
        </p>
      </div>
    </div>
  </footer>
);
